/* This file is autogenerated, see readme.md for instructions */
import CalendarAltSvgIcon from '@bloomreach/banana-theme/icons/calendar-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CalendarAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CalendarAltSvgIcon />
    </Icon>
  );
});

CalendarAltIcon.displayName = 'CalendarAltIcon';

export default CalendarAltIcon;
